import { EdgeCreateProCheckoutSessionRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CreateProCheckoutSession } from '@/modules/auth/use-cases'

export function makeCreateProCheckoutSession(): CreateProCheckoutSession {
  return new EdgeCreateProCheckoutSessionRepository(makeSupabaseEdgeHttpClient()).execute
}
